import { createContext } from '../../utils';
import type { TagProps } from './tag';

type TagContextValue = {
  controlled: boolean;
  setControlledOpen: (open: boolean) => void;
} & Pick<TagProps, 'open' | 'onOpenChange' | 'disabled'>;

export const [TagProvider, useTag] = createContext<TagContextValue>({
  rootComponentName: 'Tag',
});
